
const VehicleCondition = {
    NEW: "Nowy",
    USED: "Używany",
    DEMO: "Podemonstracyjny"
}

export default VehicleCondition;